import { render, staticRenderFns } from "./PatientModal.vue?vue&type=template&id=c1e6cdc2"
import script from "./PatientModal.vue?vue&type=script&lang=js"
export * from "./PatientModal.vue?vue&type=script&lang=js"
import style0 from "./PatientModal.vue?vue&type=style&index=0&id=c1e6cdc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports